import axios from "axios";

export async function getDatasetByID(id: number) {
  try {
    let response = await axios.get("/psql/tabular_datasets", {
      params: {
        id: `eq.${id}`,
        select:
          "*,document(*),source(*),geo_entity:geo_entities(*),user:users(*),records:tabular_datasets_records(*)",
      },
      headers: {
        Accept: "application/vnd.pgrst.object+json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function getDatasetsByConditions(conditions: object) {
  try {
    let response = await axios.get("/psql/tabular_datasets", {
      params: {
        select:
          "*,document(*),source(*),geo_entity:geo_entities(*),user:users(*)",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
}

// export function insertDataset() {}
// export function updateDatasetByID() {}
// export function deleteDatasetByID() {}
